import catalogue from './films.json';
import assetRegister from './assets.json';

export const films = catalogue.films;
export const featuredFilm = films.find(film => film.youtube_id === catalogue.featured_youtube_id);
export const filmById = id => films.find(film => film.youtube_id === id);
export const mediaPath = name => `/media/tlb/${name.replace(/^media\//, '')}`;
export const posterFor = film => film.poster_asset ? mediaPath(film.poster_asset) : mediaPath(`${film.youtube_id}.jpg`);
export const disclosureFor = film => assetRegister.assets.find(asset => `media/${asset.asset}` === film.poster_asset)?.disclosure;
export const filmDate = film => new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${film.published_date}T00:00:00Z`));
export const threads = [
  { id: 'follow-the-water', title: 'Follow the water', ids: ['AC0qXKpPb2g', 'nqnf63c7A_w', '1L060Fsusag'] },
  { id: 'life-in-the-sea', title: 'Life in the sea', ids: ['Cn5rS20BVj4'] },
  { id: 'evidence-and-judgement', title: 'Evidence and judgement', ids: ['UQO-Rl_6Dk0', 'k9RF9YJeV2w'] },
  { id: 'start-here', title: 'Start here', ids: ['RXCbE9u2NjA'] },
];